import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { addDoc, collection, setDoc } from "firebase/firestore";
import { storage, db } from "../../../../firebase";

/**
 * Uploads a file to Firebase Storage and creates a Firestore document with metadata.
 *
 * Firestore path:
 * /users/{userID}/folders/{folderId}/subfolders/{subfolderIndex}/files/{fileId}
 *
 * Storage path:
 * /users/{userId}/folders/{folderId}/{classificationCategory}
 *
 * @param {File} file - The file to upload
 * @param {string} userId - The ID of the user uploading the file
 * @param {string} folderId - The ID of the folder containing the subfolder
 * @param {number} subfolderIndex - Numeric index of the subfolder (0-7)
 * @param {string} classificationCategory - The category name (subfolderName)
 * @param {(progress: number) => void} onProgress - Optional callback for upload progress (0-100)
 * @returns {Promise<void>} - Resolves when upload and Firestore write are complete
 */
export async function uploadFileUser(
  file,
  folderId,
  userId,
  subfolderIndex,
  classificationCategory
) {
  // Map index to category name for storage path
  const subfolderNames = [
    "Leadership and Governance",
    "Quality Assurance",
    "Research",
    "Teaching and Learning",
    "Resource Management",
    "Student Services",
    "External Relations",
  ];
  const categoryName = subfolderNames[subfolderIndex];

  if (
    !file ||
    !userId ||
    !folderId ||
    subfolderIndex === undefined ||
    !classificationCategory
  ) {
    throw new Error("Missing required parameters for file upload.");
  }

  console.log(categoryName);
  const storagePath = `users/${userId}/folders/${folderId}/${categoryName}/${file.name}`;
  const storageRef = ref(storage, storagePath);

  // Upload file (no progress tracking)
  await uploadBytes(storageRef, file);

  // Get download URL
  const downloadURL = await getDownloadURL(storageRef);

  // Save metadata to Firestore
  const filesCollectionRef = collection(
    db,
    "users",
    userId,
    "folders",
    folderId,
    "subfolders",
    subfolderIndex.toString(),
    "files"
  );

  const fileMetadata = {
    classificationCategory,
    subfolderName: classificationCategory,
    downloadURL,
    fileId: file.name,
    fileName: file.name,
    fileSize: file.size,
    fileType: file.type,
    folderId,
    storagePath,
    userId,
  };

  const fileDocRef = await addDoc(filesCollectionRef, fileMetadata);
  await setDoc(fileDocRef, { ...fileMetadata, fileId: fileDocRef.id });

  alert("File upload successful.");
}
